import { Outlet, ScrollRestoration } from 'react-router';
import { Toaster } from '@/components/ui/Toaster';
import { RouteAnnouncer } from './RouteAnnouncer';
import { RouteProgress } from './RouteProgress';
import { SkipLink } from './SkipLink';

/**
 * The frame around the back-office (`/admin/*`). It is deliberately not the public shell: no
 * marketing header or footer, announcement bar, quick-contact dock, consent bar or custom cursor.
 * It supplies what every page needs — skip link, route progress, route announcer, toasts and scroll
 * restoration —. The admin layout route inside it renders
 * the navigation and `<main id="main">`.
 */
export function AdminFrame() {
  return (
    <div className="admin-frame">
      <SkipLink />
      <RouteProgress />
      <RouteAnnouncer />
      <Outlet />
      <Toaster />
      <ScrollRestoration />
    </div>
  );
}
